// src/components/RegistrationForm.js - Add sales link at bottom
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance, loginRequest } from "../msalConfig";
import { useAuth } from "../context/AuthContext";
import { signup } from "../api/authApi";
import { getAuthApiToken } from "../api/tokenService";
import ContactSales from "./ContactSales";

export default function RegistrationForm() {
  const { login } = useAuth();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showContactSales, setShowContactSales] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const loginResponse = await msalInstance.loginRedirect(loginRequest);
      const account = loginResponse.account;
      const companyName = account.idTokenClaims?.extension_CompanyName;
      const apiToken = await getAuthApiToken(account);
      await signup(apiToken, companyName);
      login(account, loginResponse.idToken);
      navigate("/IncidentForm");
    } catch (err) {
      console.error("Registration error:", err);
      setError("Registration failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        {error && <div className="error-message">{error}</div>}

        <button
          className="auth-button"
          onClick={handleRegister}
          disabled={isLoading}
        >
          {isLoading ? (
            "Creating your account..."
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z" />
              </svg>
              Start 14-Day Free Trial
              <span style={{ fontSize: "1.2rem", marginLeft: "4px" }}>→</span>
            </>
          )}
        </button>

        <div style={{ marginTop: "0.8rem", textAlign: "center" }}>
          <p style={{ fontSize: "0.7rem", color: "#64748b" }}>
            No credit card required · Cancel anytime
          </p>
          <p style={{ fontSize: "0.7rem", color: "#64748b", marginTop: "0.5rem" }}>
            Need enterprise pricing?{" "}
            <span
              onClick={() => setShowContactSales(true)}
              style={{
                color: "#8b5cf6",
                cursor: "pointer",
                fontWeight: 600,
                textDecoration: "underline"
              }}
            >
              Contact sales
            </span>
          </p>
        </div>
      </div>

      {showContactSales && <ContactSales onClose={() => setShowContactSales(false)} />}
    </>
  );
}